import type { Snapshot } from '@ember-data/legacy-compat/-private';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import type { BenchmarkInsightCompetitorsCompset } from 'lumen/models';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class CompsetSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    compset: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: BenchmarkInsightCompetitorsCompset,
    id: string | number,
    requestType: string,
  ) {
    const normalizedPayload = {
      'benchmark-insight/competitors/compset': {
        ...payload,
      },
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeResponse(
      store,
      primaryModelClass,
      normalizedPayload,
      id,
      requestType,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  serialize(snapshot: Snapshot) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const serializedData = super.serialize(snapshot);

    return {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      compset: serializedData.compset,
    };
  }

  serializeIntoHash(
    hash: BenchmarkInsightCompetitorsCompset,
    _ModelClass: unknown,
    snapshot: Snapshot,
    options: object,
  ): void {
    /*
          By default, the payload for saving a record would be:
          {
              benchmarkInsight/competitors/compset: {
                  compset: []
              }
          }

          Instead, we want the payload to be:
          {
              compset: []
          }
      */
    // @ts-expect-error: Property 'serialize' does not exist on type 'CompsetSerializer'.
    const serializedData = this.serialize(snapshot, options);
    Object.assign(hash, serializedData);
  }
}
